import { render } from "./ReadAloud.vue?vue&type=template&id=21e347d6&scoped=true"
import script from "./ReadAloud.vue?vue&type=script&lang=js"
export * from "./ReadAloud.vue?vue&type=script&lang=js"

import "./ReadAloud.vue?vue&type=style&index=0&id=21e347d6&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e347d6"]])

export default __exports__